import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

export default function ScrollToQuery() {
  const location = useLocation();

  useEffect(() => {
    const parsed = qs.parse(location.search);
    const raw = parsed.scroll;
    const id = typeof raw === 'string' ? raw.replace(/[^a-z-]/gi, '') : '';
    if (!id) return;
    requestAnimationFrame(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    });
  }, [location.search]);

  return null;
}
